// extracted by mini-css-extract-plugin
module.exports = {"noteCon":"ratingAddNotes_noteCon__3-o2u","textBox":"ratingAddNotes_textBox__3RSfc","btnSubmit":"ratingAddNotes_btnSubmit__17Emh"};